/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagBaselineAvailableTagSortCriteria {
    getFixupPrototypeFunction() { return TagBaselineAvailableTagSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<TagBaselineAvailableTagSortCriteria>): TagBaselineAvailableTagSortCriteria {
        let obj = Object.assign(new TagBaselineAvailableTagSortCriteria(), model);
        TagBaselineAvailableTagSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagBaselineAvailableTagSortCriteria>): TagBaselineAvailableTagSortCriteria {
        if (!model) return null;
        return TagBaselineAvailableTagSortCriteria.newInstance(<TagBaselineAvailableTagSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagBaselineAvailableTagSortCriteria) {
        if (!obj) return;

        models.TagBaselineAvailableTagSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagBaselineAvailableTagSortCriteria): boolean {
        Object.setPrototypeOf(obj, TagBaselineAvailableTagSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.TagBaselineAvailableTagSortColumn;

    ascending: boolean;

}
